
import {
  defineComponent, onBeforeMount, reactive, nextTick,
} from 'vue';
import message from 'ant-design-vue/lib/message';
import Card from '@/core/components/UI/Card.vue';
import PreviewPdf from '@/core/components/UI/PreviewPdf.vue';
import { useAppBase } from '@/core/composables/AppBase';
import { IOcorrencia } from '@/models/Entidades/IOcorrencia';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import ServicoOcorrencia from '@/servicos/ServicoOcorrencia';
import { EStatusResposta, IResposta } from '@/core/models/IResposta';
import { EStatusOcorrencia } from '@/models/Enumeradores/EStatusOcorrencia';
import storeApp from '@/store/storeApp';
import ServicoApp from '@/servicos/ServicoApp';
import ComboPrioridade from '@/components/ComboPrioridade.vue';
import ComboOrigem from '@/components/ComboOrigem.vue';
import ComboLeiConsideracao from '@/components/ComboLeiConsideracao.vue';
import ComboUsuario from '@/components/ComboUsuario.vue';
import ComboPessoa from '@/components/ComboPessoa.vue';
import ComboTipo from '@/components/ComboTipo.vue';
import SelecionarData from '@/core/components/UI/SelecionarData.vue';
import { IEndereco } from '@/models/Entidades/IEndereco';
import { ETipoVinculo } from '@/models/Enumeradores/ETipoVinculo';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import ServicoUtilitario from '@/servicos/ServicoUtilitario';
import CampoCep from '@/core/components/UI/CampoCep.vue';
import ComboCidade from '@/components/ComboCidade.vue';
import MapPicker from '@/components/MapPicker.vue';
import OcorrenciaArquivo from '@/components/OcorrenciaArquivo.vue';
import CadastroPessoaModal from '@/components/CadastroPessoaModal.vue';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import EditorHtml from '@/core/components/UI/EditorHtml.vue';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';

export default defineComponent({
  name: 'OcorrenciaCadastro',
  components: {
    Card,
    ComunicacaoApi,
    ComboUsuario,
    ComboTipo,
    ComboPrioridade,
    ComboOrigem,
    ComboLeiConsideracao,
    ComboPessoa,
    CampoCep,
    ComboCidade,
    MapPicker,
    OcorrenciaArquivo,
    SelecionarData,
    CadastroPessoaModal,
    EditorHtml,
    PreviewPdf,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarMensagemSucesso, ocultarComunicacaoApi, obterCodigoStringRota,
    } = useAppBase();
    const servicoOcorrencia = new ServicoOcorrencia();
    const servicoApp = new ServicoApp();
    const servicoUtilitario = new ServicoUtilitario();
    const state = reactive({
      ocorrencia: {} as IOcorrencia,
      cep: '',
      apresentarCampos: false,
      apresentarMapa: false,
      apresentarCadastroPessoa: false,
      abaEnderecoLocalizacao: '1',
      abaVistoria: '1',
      bloquearCampos: false,
      gerarPdf: false,
      gerandoPdf: false,
      arquivosPdf: [] as IArquivoPdf[],
    });

    let debounce: ReturnType<typeof setTimeout> | undefined;
    function marcarAlterado() {
      state.gerarPdf = false;
    }

    async function estrategiaAlteracaoTipo() {
      marcarAlterado();
      console.log('chamou tipo');
      const definicaoOcorrencia = await servicoOcorrencia.obterDefinicaoOcorrenciaPorTipo(state.ocorrencia.codigoTipo);
      if (definicaoOcorrencia !== null && UtilitarioGeral.validaCodigo(definicaoOcorrencia.codigo)) {
        state.ocorrencia.codigoLeiConsideracao = definicaoOcorrencia.codigoLeiConsideracao;
        state.ocorrencia.descricao = definicaoOcorrencia.descricao;
      }
    }

    async function obterOcorrencia(codigo:number) {
      appBase.carregando = true;

      state.ocorrencia = await servicoOcorrencia.obter(codigo);
      if (state.ocorrencia.status === EStatusOcorrencia.Cancelada || state.ocorrencia.status === EStatusOcorrencia.Concluida) {
        state.bloquearCampos = true;
      }

      clearTimeout(debounce);

      debounce = setTimeout(async () => {
        appBase.carregando = false;

        await nextTick();

        setTimeout(() => {
          state.gerarPdf = true;
        }, 100);
      }, 650);
    }

    function cadastroAtualizado(codigo:number) {
      state.ocorrencia.codigoCadastro = codigo;
    }

    function obtemCodigoCadastro(): number {
      if (UtilitarioGeral.validaCodigo(state.ocorrencia.codigoCadastro)) {
        return state.ocorrencia.codigoCadastro;
      }

      return 0;
    }

    async function limparDados() {
      state.apresentarCampos = false;
      state.bloquearCampos = false;
      state.gerarPdf = false;
      state.gerandoPdf = false;
      state.apresentarCadastroPessoa = false;
      state.abaEnderecoLocalizacao = '1';
      state.abaVistoria = '1';
      state.ocorrencia = {} as IOcorrencia;
      state.ocorrencia.codigo = 0;
      state.ocorrencia.data = await servicoApp.obterDataAtual();
      state.ocorrencia.codigoOrigem = storeApp.state.parceiroAutenticado.codigoOrigemPadrao;
      state.ocorrencia.codigoPrioridade = storeApp.state.parceiroAutenticado.codigoPrioridadePadrao;
      state.ocorrencia.codigoUsuarioRegistro = storeApp.getters.codigoUsuarioAutenticado();
      state.ocorrencia.descricao = '<p><strong>1. OBJETIVO</strong></p> <p>Este relat&oacute;rio tem como finalidade registrar a visita t&eacute;cnica realizada pela Coordenadoria Municipal de Prote&ccedil;&atilde;o e Defesa Civil de Tai&oacute;, em raz&atilde;o de pedido feito pela senhor(a) . Pedido este para indicar as orienta&ccedil;&otilde;es e recomenda&ccedil;&otilde;es quanto &agrave; seguran&ccedil;a estrutural do im&oacute;vel no local.</p> <p><strong>2. CONSTATA&Ccedil;&Otilde;ES</strong></p> <p>Durante a inspe&ccedil;&atilde;o t&eacute;cnica in loco, verificou-se que:</p> <p><span style="font-size: 10.0pt;">&middot;</span>Existe uma estrutura de ;</p> <p><span style="font-size: 10.0pt;">&middot;</span>Verificou-se que a referida encontra com muitas avarias em sua estrutura sendo de possivelmente geradas por&nbsp;</p> <p><strong>3. RECOMENDA&Ccedil;&Otilde;ES</strong></p> <p><span style="font-size: 10.0pt;">&middot;</span><span style="font-size: 11.5pt;">Recomenda-se que o propriet&aacute;rio, por quest&otilde;es de seguran&ccedil;a, evacue a resid&ecirc;ncia imediatamente, considerando os riscos iminentes &agrave; integridade estrutural do im&oacute;vel. &Eacute; fundamental realizar uma avalia&ccedil;&atilde;o t&eacute;cnica detalhada para identificar as necessidades de uma reforma geral ou, em casos extremos, a demoli&ccedil;&atilde;o total da edifica&ccedil;&atilde;o. Tal medida &eacute; necess&aacute;ria devido &agrave;s evid&ecirc;ncias concretas de instabilidade na estrutura, que podem levar ao seu eventual colapso em condi&ccedil;&otilde;es de fortes chuvas ou ventos intensos, colocando em risco a vida e a seguran&ccedil;a dos moradores e transeuntes. Priorizar a seguran&ccedil;a deve ser a principal preocupa&ccedil;&atilde;o, evitando riscos desnecess&aacute;rios de que alguma fatalidade aconte&ccedil;a.</span></p> <p><strong>4. CONCLUS&Atilde;O</strong></p> <p>Diante do exposto, como forma de preven&ccedil;&atilde;o e mitiga&ccedil;&atilde;o de riscos contra a vida humana devesse fazer a reforma geral imediata para resguardar as vidas e o patrim&ocirc;nio.</p> <p><strong>5. ASPECTOS LEGAIS</strong></p>';
      state.ocorrencia.endereco = {} as IEndereco;
      state.ocorrencia.endereco.codigo = 0;
      state.ocorrencia.endereco.cep = storeApp.state.parceiroAutenticado.cepPadrao;
      state.ocorrencia.endereco.codigoCidade = storeApp.state.parceiroAutenticado.codigoCidadePadrao;
      state.ocorrencia.endereco.enderecoCompleto = 'Rua';
      state.ocorrencia.endereco.bairro = 'Centro';
      state.ocorrencia.endereco.codigoVinculo = 0;
      state.ocorrencia.endereco.tipoVinculo = ETipoVinculo.Ocorrencia;
      state.ocorrencia.endereco.latitude = 0;
      state.ocorrencia.endereco.longitude = 0;
      state.ocorrencia.status = EStatusOcorrencia.Aberta;
      state.ocorrencia.arquivos = [];
      state.cep = '';
      state.apresentarCampos = true;
    }

    onBeforeMount(async () => {
      limparDados();
      const codigoOcorrencia = obterCodigoStringRota();
      if (UtilitarioGeral.valorValido(codigoOcorrencia)) {
        const codigo = UtilitarioGeral.obterCodigoDaString(codigoOcorrencia);
        await obterOcorrencia(codigo);
      }
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações do ocorrencia.');
      if (state.ocorrencia.codigo === 0) {
        appBase.resposta = await servicoOcorrencia.incluir(state.ocorrencia);
      } else {
        appBase.resposta = await servicoOcorrencia.atualizar(state.ocorrencia);
      }
      if (appBase.resposta.status === EStatusResposta.Sucesso) {
        ocultarComunicacaoApi();
        if (state.ocorrencia.codigo === 0) {
          apresentarMensagemSucesso('Ocorrência criada com sucesso!');
          await obterOcorrencia(appBase.resposta.codigo);
        } else {
          apresentarMensagemSucesso('Ocorrência atualizada com sucesso!');
        }
        state.gerarPdf = true;
      }
    }

    async function gerarPdf() {
      state.gerandoPdf = true;
      const retornoRelatorio = await servicoOcorrencia.gerarPdf(state.ocorrencia.codigo);
      state.gerandoPdf = false;
      if (retornoRelatorio.status === EStatusResposta.Sucesso) {
        if (UtilitarioGeral.valorValido(retornoRelatorio.link)) {
          state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        }
      } else {
        message.warn(retornoRelatorio.mensagem);
      }
    }

    async function atualizarStatus(status:EStatusOcorrencia) {
      state.ocorrencia.status = status;
      await salvar();
    }

    async function consultaCep() {
      if (UtilitarioGeral.valorValido(state.ocorrencia.endereco.cep) && UtilitarioGeral.validaValorComLimiteCaracteres(state.ocorrencia.endereco.cep, 8)) {
        if (state.ocorrencia.endereco.cep !== state.cep) {
          const retornoConsultaCep = await servicoUtilitario.consultaCep(state.ocorrencia.endereco.cep);
          if (retornoConsultaCep !== undefined) {
            state.ocorrencia.endereco.enderecoCompleto = retornoConsultaCep.logradouro;
            state.ocorrencia.endereco.complemento = retornoConsultaCep.complemento;
            state.ocorrencia.endereco.bairro = retornoConsultaCep.bairro;
            state.ocorrencia.endereco.codigoCidade = retornoConsultaCep.codigoCidade;
            state.cep = state.ocorrencia.endereco.cep;
          }
        }
      }
    }

    function apresentarMapa() {
      if (state.abaEnderecoLocalizacao === '2') {
        if (state.ocorrencia.endereco.latitude === 0 && state.ocorrencia.endereco.longitude === 0) {
          state.ocorrencia.endereco.latitude = storeApp.state.parceiroAutenticado.coordenadasLatitudePadrao;
          state.ocorrencia.endereco.longitude = storeApp.state.parceiroAutenticado.coordenadasLongitudePadrao;
        }
        state.apresentarMapa = true;
      }
    }
    return {
      appBase,
      state,
      salvar,
      consultaCep,
      apresentarMapa,
      cadastroAtualizado,
      obtemCodigoCadastro,
      UtilitarioData,
      servicoOcorrencia,
      atualizarStatus,
      EStatusOcorrencia,
      gerarPdf,
      marcarAlterado,
      estrategiaAlteracaoTipo,
    };
  },
});
